import React, { useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/Button';
const links = [{
  label: 'For Brands',
  to: '/for-brands'
}, {
  label: 'For Marketing Agencies',
  to: '/for-marketing-agencies'
}, {
  label: 'For Talent Agencies',
  to: '/for-talent'
}, {
  label: 'Case Studies',
  to: '/case-studies'
}, {
  label: 'Pricing',
  to: '/pricing'
}];
export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const close = () => setIsOpen(false);
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-100" data-id="element-885">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-886">
        <div className="flex justify-between items-center h-16" data-id="element-887">
          <div className="flex items-center" data-id="element-888">
            <Link to="/" onClick={close} className="flex-shrink-0 flex items-center" data-id="element-889">
              <img src="https://cdn.magicpatterns.com/uploads/gbY7Dn8gGgHtYDAdDbncPd/zano_logo_full1.png" alt="Zano" className="h-7 w-auto" data-id="element-890" />
            </Link>
            <div className="hidden md:ml-10 md:flex md:space-x-7" data-id="element-891">
              {links.map(l => <NavLink key={l.to} to={l.to} className={({
              isActive
            }) => `text-sm font-medium transition-colors ${isActive ? 'text-zano-pink' : 'text-gray-600 hover:text-zano-charcoal'}`} data-id="element-892">
                  {l.label}
                </NavLink>)}
            </div>
          </div>
          <div className="hidden md:flex items-center space-x-4" data-id="element-893">
            <a href="https://app.zanoplatform.com/sign-in" className="text-sm font-medium transition-colors text-gray-600 hover:text-zano-charcoal" data-id="element-894">
              Login
            </a>
            <Button variant="primary" onClick={() => navigate('/pricing')} data-id="element-895">
              Start Free Trial
            </Button>
          </div>
          <div className="flex items-center md:hidden" data-id="element-896">
            <button onClick={() => setIsOpen(!isOpen)} className="text-gray-600 hover:text-zano-charcoal" data-id="element-897">
              {isOpen ? <X size={24} data-id="element-898" /> : <Menu size={24} data-id="element-899" />}
            </button>
          </div>
        </div>
      </div>
      {isOpen && <div className="md:hidden bg-white border-b border-gray-100 px-4 pt-2 pb-4 space-y-1" data-id="element-900">
          {links.map(l => <NavLink key={l.to} to={l.to} onClick={close} className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-zano-charcoal hover:bg-gray-50" data-id="element-901">
              {l.label}
            </NavLink>)}
          <div className="mt-4 pt-4 border-t border-gray-100 flex flex-col gap-2" data-id="element-902">
            <a href="https://app.zanoplatform.com/sign-in" onClick={close} data-id="element-903">
              <Button variant="secondary" className="w-full justify-center" data-id="element-904">
                Login
              </Button>
            </a>
            <Link to="/pricing" onClick={close} data-id="element-905">
              <Button variant="primary" className="w-full justify-center" data-id="element-906">
                Start Free Trial
              </Button>
            </Link>
          </div>
        </div>}
    </nav>;
};